<template>
  <button
    type="button"
    class="btn btn-scroll-up  btn-warning shadow c-p-3 stretched-link c-rounded-pill border-0 fixed"
    aria-label="scroll up"
    @click="scrollTop"
  >
    <i class="mi-chevron-u" />
  </button>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const showScrollUp = () => {
  const scrollUpBtn = document.querySelector('.btn-scroll-up')
  if (scrollUpBtn) {
    if (window.scrollY > window.innerHeight / 2) scrollUpBtn.classList.add('btn-scroll-up-show')
    else scrollUpBtn.classList.remove('btn-scroll-up-show')
  }
}

onMounted(() => {
  window.addEventListener('scroll', showScrollUp)
})
</script>

<style lang="scss">
.btn-scroll-up {
    right: -60px;
    bottom: 10px;
    z-index: 30;
    transition: right .3s;
    transition-timing-function: ease-in-out;
    transition-delay: .1s;

    &-show{
        right: 15px;
        transition-delay: 0s;
    }

    @media screen and (max-width: 991px) {
        display: none;
    }
}
</style>
